import { useState } from "react";

function IntermediateOptionsStrategiesModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Review of Basic Concepts",
      content: [
        "Quick recap of options basics: Calls, puts, and the Greeks.",
        "Importance of implied volatility and time decay.",
        "Reviewing single-leg strategies (Long Call, Long Put, Covered Call, Protective Put).",
      ],
    },
    {
      title: "Module 2: Vertical Spreads",
      content: [
        "Bull Call Spread: Using a call spread to capitalize on moderate bullish outlooks.",
        "Example: Buying a lower strike call and selling a higher strike call.",
        "Bear Put Spread: Profiting from a moderately bearish market with limited risk.",
        "Example: Buying a higher strike put and selling a lower strike put.",
        "Risk/reward analysis and breakeven points for both strategies.",
      ],
    },
    {
      title: "Module 3: Horizontal (Calendar) Spreads",
      content: [
        "Long Calendar Spread: Taking advantage of time decay by using different expiration dates.",
        "Example: Buying a long-term option and selling a short-term option at the same strike price.",
        "Understanding the impact of time decay and volatility.",
        "Ideal market conditions for implementing calendar spreads.",
      ],
    },
    {
      title: "Module 4: Diagonal Spreads",
      content: [
        "Bullish Diagonal Spread: Combining elements of vertical and horizontal spreads.",
        "Example: Buying a longer-term call at a lower strike and selling a shorter-term call at a higher strike.",
        "Bearish Diagonal Spread: The opposite setup for bearish outlooks.",
        "How to adjust diagonals based on market conditions.",
      ],
    },
    {
      title: "Module 5: Straddles and Strangles",
      content: [
        "Long Straddle: Profiting from high volatility, regardless of direction.",
        "Example: Buying a call and a put at the same strike price and expiration.",
        "Long Strangle: Similar to straddles but with different strike prices.",
        "Example: Buying a call and a put at different out-of-the-money strikes.",
        "Risk/reward, breakeven points, and managing straddle/strangle trades.",
      ],
    },
    {
      title: "Module 6: Iron Condor",
      content: [
        "Iron Condor Strategy: Generating income in a low volatility market.",
        "Example: Selling an out-of-the-money call spread and an out-of-the-money put spread.",
        "How to select strike prices for maximizing premium.",
        "Managing adjustments and risk for iron condor positions.",
      ],
    },
    {
      title: "Module 7: Butterfly Spreads",
      content: [
        "Long Call Butterfly: A low-cost, low-risk strategy for range-bound markets.",
        "Example: Buying one lower strike call, selling two middle strike calls, and buying one higher strike call.",
        "Long Put Butterfly: Similar setup using puts.",
        "Key considerations for butterfly setups, including expiration and strike selection.",
      ],
    },
    {
      title: "Module 8: Ratio Spreads",
      content: [
        "Call Ratio Spread: Leveraging directional bias with limited risk.",
        "Example: Buying one call and selling two calls at a higher strike.",
        "Put Ratio Spread: A bearish alternative using puts.",
        "Understanding risk exposure and adjusting ratio spreads.",
      ],
    },
    {
      title: "Module 9: Iron Butterfly",
      content: [
        "Iron Butterfly Strategy: A more aggressive version of the iron condor.",
        "Example: Selling an at-the-money straddle and buying protective wings.",
        "Profitability analysis in different volatility scenarios.",
        "How to adjust positions based on market movement.",
      ],
    },
    {
      title: "Module 10: Options Strategies for Earnings Announcements",
      content: [
        "Strategies for capturing volatility crush post-earnings.",
        "Pre-Earnings Straddle/Strangle: Betting on volatility spikes.",
        "Post-Earnings Iron Condor: Capturing premium after earnings announcements.",
      ],
    },
    {
      title: "Module 11: Risk Management Techniques",
      content: [
        "Adjusting positions when trades move against you.",
        "Using stop-loss orders and alerts.",
        "Hedging strategies with options to protect existing trades.",
        "Importance of position sizing and portfolio diversification.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Intermediate Options Strategies Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ddd",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: "1px solid #ddd",
                    borderTop: "none",
                    backgroundColor: "#ffffff",
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "8px",
                        backgroundColor: "#fdfdfd",
                      }}
                    >
                      <span style={{ color: "#007bff", marginRight: "8px" }}>➤</span>
                      <p className="m-0" style={{ fontSize: "14px", color: "#333" }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IntermediateOptionsStrategiesModule;
